import process from 'process/browser';

window.process = process;
